<template>
  <div>
    <el-tooltip v-if="hasOverflow"
                popper-class="overflow-tooltip"
                :content="text"
                placement="top"
                :open-delay="400">
      <div class="overflow-text">
        {{truncatedText}}
      </div>
    </el-tooltip>
    <template v-else>
      {{text}}
    </template>
  </div>
</template>
<script>
  export default {
    name: 'text-overflow-tooltip',
    props: {
      text: String
    },
    data () {
      return {
        charLimit: 80
      }
    },
    computed: {
      hasOverflow () {
        return this.text && this.text.length > this.charLimit
      },
      truncatedText () {
        if (this.hasOverflow) {
          return `${this.text.substring(0, this.charLimit)}...`
        }
        return this.text
      }
    }
  }
</script>
<style>
  .overflow-tooltip {
    max-width: 600px;
  }
</style>
